import { ITaxExemptionFormOptions } from "JS/types/TaxExemption";

export const AUTO_TAX_EXEMPT_POPUP_PARAM = 'tax_exempt_popup';

export function createCartAutoTaxExemptPopupUrl() {
	const refUrl = `/cart/?${AUTO_TAX_EXEMPT_POPUP_PARAM}`;
	// will automatically redirect to the correct place if already valid, too
	const accountVerifyUrl = `/account/verify/?refUrl=${encodeURIComponent(refUrl)}`;
	return accountVerifyUrl;
}

export type VertexOverride = {
	qId: number;
	value: string;
}

export function createVertexOverrides(options: ITaxExemptionFormOptions): VertexOverride[] {
	const overrides: VertexOverride[] = [];

	if (options.buyerName) {
		overrides.push({ qId: 2, value: options.buyerName });
	}
	if (options.buyerStreetAddress) {
		overrides.push({ qId: 3, value: options.buyerStreetAddress });
	}
	if (options.buyerCity) {
		overrides.push({ qId: 4, value: options.buyerCity });
	}
	if (options.buyerState) {
		overrides.push({ qId: 5, value: options.buyerState });
	}
	if (options.buyerPostalCode) {
		overrides.push({ qId: 6, value: options.buyerPostalCode });
	}
	if (options.buyerCountry) {
		overrides.push({ qId: 7, value: options.buyerCountry });
	}
	if (options.buyerEmail) {
		overrides.push({ qId: 19, value: options.buyerEmail });
	}
	if (options.buyerPhone) {
		overrides.push({ qId: 22, value: options.buyerPhone });
	}

	return overrides;
}